import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

type TSectionLinkProps = {
  href: string;
  label: string;
  className?: string;
};

/**
 * Shared "see more" link used below content sections (blog, proposals, cities…).
 * Gold, uppercase Oswald + arrow — matches the cities section link for consistency.
 */
export const SectionLink = ({ href, label, className = '' }: TSectionLinkProps) => {
  return (
    <Link
      href={href}
      className={`group inline-flex items-center gap-2 font-oswald uppercase tracking-wide text-action transition-opacity hover:opacity-80 ${className}`}
    >
      {label}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden />
    </Link>
  );
};
